module.exports = "/static/assets/a7b8435328fd6d9605bc47218b0151ab.svg";